module.exports = __webpack_public_path__ + "img/picture_slt01.69d609d1.png";